import { hotEvents } from "@/mocks/events";
import SectionHeading from "./SectionHeading";
import StatusTag from "./StatusTag";

export default function DeepTimeline() {
  const featured = hotEvents.filter((e) => e.featured);

  return (
    <section id="deep" className="border-y border-background-200 bg-background-100/60 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="深度时间线"
          title="把一件事，从头到尾讲透"
          description="针对仍在持续或已被反复讨论的重点事件，我们用更细的节点和更完整的前因后果做深度梳理，越往下滑，看得越清楚。"
        />

        <div className="mt-10 flex flex-col gap-10">
          {featured.map((event, idx) => (
            <article
              key={event.id}
              className="overflow-hidden rounded-2xl border border-background-200 bg-background-50 shadow-hairline"
            >
              <div className="border-b border-background-200 bg-background-50 p-5 md:p-7">
                <div className="flex flex-wrap items-center gap-2 text-xs font-medium text-foreground-500">
                  <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-1 font-semibold text-accent-800">
                    <i className="ri-focus-3-line" />
                    深度专题 {String(idx + 1).padStart(2, "0")}
                  </span>
                  <span>{event.category}</span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line" />更新 {event.updated}
                  </span>
                  <span className="inline-flex items-center gap-1 text-primary-600">
                    <i className="ri-fire-fill" />热度 {event.heat}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-900 md:text-3xl">
                  {event.title}
                </h3>
              </div>

              <div className="grid lg:grid-cols-[1fr_1.5fr]">
                <div className="space-y-4 border-b border-background-200 p-5 lg:border-b-0 lg:border-r md:p-7">
                  <div className="rounded-xl bg-background-100 p-4">
                    <div className="flex items-center gap-2 text-sm font-bold text-foreground-900">
                      <i className="ri-seedling-line text-primary-600" />
                      起因 · 一粒瓜种
                    </div>
                    <p className="mt-2 text-[13px] leading-relaxed text-foreground-700">{event.cause}</p>
                  </div>

                  <div className="rounded-xl border border-secondary-200 bg-secondary-50 p-4">
                    <div className="flex items-center gap-2 text-sm font-bold text-secondary-900">
                      <i className="ri-checkbox-circle-line" />
                      当前定论
                    </div>
                    <p className="mt-2 text-[13px] leading-relaxed text-foreground-700">{event.result}</p>
                  </div>

                  <div className="flex flex-wrap items-center gap-2">
                    <StatusTag status={event.status} />
                    {event.tags.map((t) => (
                      <span
                        key={t}
                        className="whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-2.5 py-1 text-[11px] font-medium text-foreground-600"
                      >
                        #{t}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="p-5 md:p-7">
                  <div className="mb-5 flex items-center gap-2 text-sm font-bold text-foreground-900">
                    <i className="ri-time-line text-accent-700" />
                    关键节点时间线
                    <span className="text-xs font-normal text-foreground-500">（{event.steps.length} 个节点）</span>
                  </div>
                  <ol className="relative ml-2 space-y-5 border-l-2 border-accent-200 pl-6">
                    {event.steps.map((step) => (
                      <li key={step.date + step.title} className="relative">
                        <span className="absolute -left-[35px] top-0 flex h-6 w-6 items-center justify-center rounded-full bg-accent-500 text-[10px] font-bold text-background-50 ring-4 ring-accent-100">
                          <i className="ri-record-circle-fill" />
                        </span>
                        <span className="inline-flex rounded-md bg-accent-100 px-2 py-0.5 text-xs font-bold text-accent-800">
                          {step.date}
                        </span>
                        <h4 className="mt-2 font-heading text-base font-bold text-foreground-900 md:text-lg">{step.title}</h4>
                        <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{step.text}</p>
                      </li>
                    ))}
                  </ol>
                  <div className="mt-6 flex items-center gap-3 rounded-xl border border-accent-200 bg-accent-50 px-4 py-3">
                    <i className="ri-lightbulb-flash-line text-accent-700" />
                    <p className="text-xs leading-relaxed text-accent-900">
                      标注说明：时间线仅梳理公开信息，区分「已确认」「双方说法」「尚未证实」，不代表任何一方立场，请以官方与权威发布为准。
                    </p>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}